<template>
  <item-dialog ref="dialog" @refresh="$emit('refresh', $event)" />
</template>

<script>
import ItemDialog from './ItemDialog.vue'

export default {
  name: 'EditWhItem',

  components: {
    ItemDialog
  },

  methods: {
    open (item) {
      this.$refs.dialog.open(item)
    },

    close () {
      this.$refs.dialog.close()
    }
  }
}
</script>
